import translate from '@translate';
import { WebhookMethod, WebhookType } from 'skladon-types';
import { ConstantsCodeType } from 'src/types/constantsCodes';

export const getWebhookTypeSelectOptions = (): ConstantsCodeType[] =>
    Object.values(WebhookType).map((value) => ({
        value,
        label: translate(`webhooks.webhookType.${value}`),
    }));

export const getWebhookMethodSelectOptions = (): ConstantsCodeType[] =>
    Object.values(WebhookMethod).map((value) => ({
        value,
        label: value,
    }));
